import { useState } from 'react';
import { host } from '@branding/config';

export const useQueryGetAttachmentURL = (): {
	isLoading: boolean;
	getAttachment: (attachmentId: string) => Promise<any>;
	downloadAttachment: (attachmentId: string) => Promise<void>;
	error: Error | null;
} => {
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [error, setError] = useState<Error | null>(null);
	const downloadAttachment = async (attachmentId: string) => {
		const res = await getAttachment(attachmentId);
		const a = document.createElement('a');
		a.href = res.signedURL;
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	};

	const getAttachment = async (attachmentId: string) => {
		setIsLoading(true);

		const url = new URL(host + '/api/getAttachment');
		url.searchParams.set('attachmentId', attachmentId);

		const requestOptions: RequestInit = {
			method: 'GET',
			credentials: 'include',
			headers: {
				'Content-Type': 'application/json',
			},
		};

		return await fetch(url, requestOptions)
			.then((res) => {
				return res.json();
			})
			.then((resData) => {
				if (resData.status === 'error') {
					setError(new Error(resData.message));
					throw new Error(resData.message);
				}
				setIsLoading(false);
				return resData;
			})
			.catch((err) => {
				setIsLoading(false);
				setError(new Error('Error getting attachment'));
				throw new Error(err);
			})
			.finally(() => {
				setTimeout(() => {
					setError(null);
				}, 6000);
				setIsLoading(false);
			});
	};

	return { isLoading, getAttachment, downloadAttachment, error };
};
